<p>De zomer in je bol en zin in een lekkere bbq?</p>
<p>Verjaardag of familie feestje?</p>
<p>Bij ons kunt u terecht voor onder andere gezellige statafels en een mooie partytent om het compleet te maken!</p>
<p><a href="/prijzen" routerLink="prijzen">Klik hier om onze producten in te zien</a></p>
<p><small>Feestverhuur Molenlanden<br>Telefoonummer: <a href="tel:0638888091">0638888091</a></small></p>
